import _ from 'lodash';
import { getRequest } from '../../Common/network-call';

// constant
import { TABLE_URI_ADDON } from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const FETCH_ALL_EVENT_MAPS = 'FETCH_ALL_EVENT_MAPS';
export const SET_MAP_DETAILS = 'SET_MAP_DETAILS';

export const fetchEventMaps = (session, callback) => {
  const locationFilter = encodeURI(`(eventid=${session.eventid})`);
  const locationUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.locationmaps}?include_count=true&fields=${FIELDS.locationmaps.maxInfo}&filter=${locationFilter}&order=${FETCH_ORDERS.locationmaps.api}`;

  const iMapFilter = encodeURI(
    `((eventid=${session.eventid})AND((maptype=imap)OR((maptype=booth)AND(isvisibleinsideimap=1)AND(status='live'))))`
  );
  const interactiveUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.interactivemaps}?include_count=true&fields=${FIELDS.interactivemaps.mediumInfo}&filter=${iMapFilter}`;

  return dispatch => {
    getRequest(
      locationUrl,
      session,
      dispatch,
      resLoc => {
        let mapsArr = resLoc?.resource;
        let mapCount = resLoc.meta.count;

        getRequest(
          interactiveUrl,
          session,
          dispatch,
          resInter => {
            let payload = {
              data: _.orderBy(
                _.concat(mapsArr, resInter?.resource),
                ['displayorder'],
                ['asc']
              ),
              count: mapCount + resInter.meta.count
            };

            dispatch({
              type: FETCH_ALL_EVENT_MAPS,
              payload
            });
            callback({ success: 1, data: payload, error: null });
          },

          errorInter => {
            let payload = {
              data: mapsArr,
              count: mapCount
            };

            dispatch({
              type: FETCH_ALL_EVENT_MAPS,
              payload
            });
            callback({ success: 1, data: payload, error: errorInter });
          }
        );
      },
      errorLoc => {
        callback({ success: 0, data: null, error: errorLoc });
      }
    );
  };
};

export const clearEventMaps = () => {
  return dispatch => {
    dispatch({ type: FETCH_ALL_EVENT_MAPS, payload: {} });
  };
};

export const setMapDetails = value => {
  return dispatch => {
    dispatch({ type: SET_MAP_DETAILS, payload: value });
  };
};

export const clearMapDetails = () => {
  return dispatch => {
    dispatch({ type: SET_MAP_DETAILS, payload: {} });
  };
};

export const fetchInteractiveMapDetails = (session, mapId, callback) => {
  let related = `interactivemap_locations_by_interactivemapid,interactivemap_locations_by_interactivemaplocation_exhibitor_link,exhibitors_by_interactivemaplocation_exhibitor_link,interactivemaplocation_exhibitor_link_by_interactivemapid,session_by_interactivemaplocation_session_link,interactivemaplocation_session_link_by_interactivemapid,speaker_by_interactivemaplocation_speaker_link,interactivemaplocation_speaker_link_by_interactivemapid,sponsor_by_interactivemaplocation_sponsor_link,interactivemaplocation_sponsor_link_by_interactivemapid`;
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(interactivemapid=${mapId})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.interactivemaps}?related=${related}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res.resource[0] });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
